import analyticstracker from "@jmc/analyticstracker";
import { useCookieInteraction } from "@jmc/core/src/hooks/useCookieInteraction/index";
import { EventTypes } from "@jmc/core/src/types/EventTypes";
import { useEventListener } from "@jmc/utils/hooks/useEventListener";
import { useOnScreen } from "@jmc/utils/hooks/useOnScreen";
import { useScroll } from "@jmc/utils/hooks/useScroll";
import React, { useEffect, useRef, useState } from "react";
export interface PropTypes {
    children: JSX.Element | JSX.Element[] | React.ReactNode | string;
    open?: boolean;
    name?: string;
}

const AccordionPaneImpression: React.FunctionComponent<PropTypes> = (props: PropTypes) => {
    const { open, name, children } = props;
    const { interacted } = useCookieInteraction();

    const pane = useRef<HTMLDivElement>(null);
    const inViewport = useOnScreen(pane);

    const [isOpen, setIsopen] = useState(open);

    useScroll(() => {
        setTimeout(() => {
            analyticstracker().trackImpression(EventTypes.ACCORDIONPANE_IMPRESSION);
        }, 1000);
    }, 500);

    useEffect(() => {
        if (inViewport && interacted) {
            setTimeout(() => {
                analyticstracker().trackImpression(EventTypes.ACCORDIONPANE_IMPRESSION);
            }, 1000);
        }
    }, [inViewport, interacted]);

    useEventListener(
        "accordionClick",
        () => {
            setIsopen(!isOpen);
            analyticstracker().trackEvent({
                event: EventTypes.ACCORDIONPANE_CLICK,
                info: {
                    name,
                    state: !isOpen ? "visible" : "hidden",
                },
            });
        },
        pane,
    );

    return (
        <div
            data-tracking-event={EventTypes.ACCORDIONPANE_IMPRESSION}
            data-tracking-info={JSON.stringify({
                name,
                state: open ? "visible" : "hidden",
            })}
            ref={pane}
        >
            {children}
        </div>
    );
};

export default AccordionPaneImpression;
